import { FC } from 'react';
import { Button, ButtonProps } from '../ui/button';

export type SubmitButtonProps = Omit<
  ButtonProps,
  'children' | 'type' | 'variant'
> & {
  text?: string;
};

export const SubmitButton: FC<SubmitButtonProps> = ({
  text = 'Submit',
  ...props
}) => (
  <Button {...props} type="submit">
    {text}
  </Button>
);
